export default __webpack_public_path__ + "static/media/arrowBack.62046210.svg";